import {useQuery} from '@tanstack/react-query';

import {
  getUnmappedExternalSubCategories,
  GetUnmappedExternalSubCategoriesParams,
} from '../api';
import {QUERY__UNMAPPED_EXTERNAL_SUB_CATEGORIES} from '../queryKeys';
import {ExternalSubCategory} from '../types';

import {GetListOutput, QueryOptionsForList} from '@/shared/api';

export const useGetUnmappedExternalSubCategories = <
  SelectedData = GetListOutput<ExternalSubCategory>,
>(
  params?: GetUnmappedExternalSubCategoriesParams,
  options?: QueryOptionsForList<ExternalSubCategory, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__UNMAPPED_EXTERNAL_SUB_CATEGORIES, params],
    queryFn: () => getUnmappedExternalSubCategories(params),
    ...options,
  });
};
